import type { Tool } from './types'
import type { ComponentType } from 'react'
import { CalendarDays, GraduationCap, type LucideIcon } from 'lucide-react'
import { NorseTermNav, NorseTermBadge } from '../modules/norseterm/ChecklistView'
import { FlexPdNav, FlexPdBadge } from '../modules/flexpd/FlexPd'

/**
 * The module registry. Adding an app to SailNorse is a folder plus one entry
 * here — that is the entire payoff of the shared shell, and you feel it on
 * app number three.
 *
 * Note there is no building in any of these paths. Scope is a property of the
 * grant and a filter on the view, never a path segment.
 */
export interface ModuleDef {
  id: Tool
  title: string
  blurb: string
  /**
   * Lucide, not emoji. Emoji render as a different picture on every platform,
   * cannot inherit colour (so they stay bright on a disabled tile), and get
   * announced as words by screen readers next to a label that already says it.
   * These are decorative — always aria-hidden, never the only signal.
   */
  icon: LucideIcon
  path: string
  /** Tile is hidden unless the signed-in user holds a grant for this tool. */
  requires: Tool
  enabled: boolean
  /** Shown under the tool's link in the desktop rail — NorseTerm's queues and checklist. */
  NavChildren?: ComponentType
  /** A count beside the tool's name — what is waiting on this person. */
  Badge?: ComponentType
}

// `enabled: false` renders the tile greyed out as "Coming soon" rather than
// hiding it. A dead tile that navigates nowhere is worse than either — flip
// this the same commit the screens land, not before.
export const MODULES: ModuleDef[] = [
  { id: 'norseterm', title: 'NorseTerm', blurb: 'Courses & placement', icon: CalendarDays, path: '/norseterm', requires: 'norseterm', enabled: true, NavChildren: NorseTermNav, Badge: NorseTermBadge },
  { id: 'flexpd', title: 'Flex PD', blurb: 'Professional development hours', icon: GraduationCap, path: '/flex-pd', requires: 'flexpd', enabled: true, NavChildren: FlexPdNav, Badge: FlexPdBadge },
]
